

import {Location} from './location';
import {Document} from './document';
import {Chat} from './chat';
import {Partner} from './partner/partner';
import {Flow} from './flow';
import {Equipment} from './equipment';
import {Currency} from './currency';
import {ServicePricing} from './service-pricing';
import {ServiceOrder, ServiceOrderTemplate} from './service-order';
import {Project} from './project';
import {Company} from './companies';

export interface Service {
  id: number;
  description: string;
  name: string;
  projectId?: number;
  supplierId?: number; // @deprecated - Usar supplierIds en su lugar
  supplierIds?: number[]; // Lista de IDs de suppliers (puede estar vacía o no existir)
  forwarderId?: number;
  shipperId?: number;
  consigneeId?: number;
  technicalSpecifications?: string;
  startDatePlan?: string;
  endDatePlan?: string;
  unitValueLoad?: any;
  unitValueLoadCurrency?: any;
  transportTypeId?: number;
  originId?: number;
  destinationId?: number;
  originContactId?: number;
  destinationContactId?: number;
  customsAgency?: string;
  packaging?: string;
  storage?: string;
  cargoInsurance?: string;
  temperature?: string;
  serviceParentId?: number;
  typeId?: number;
  storageFeeld?: number;
  demurrageFeeld?: number;
  warehouseFeeld?: number;
  isActive?: boolean;
  service?: string;
  integrate: boolean;
  frequency: string;
  totalPlanned?: number | null;
  servicePrincingId?: number;
  serviceOrderTemplate?: ServiceOrderTemplate;
  project?: Project;
  company: Company;
  customOperations?: string

  // Propiedades de front
  origin?: Location;
  destination?: Location;
  originContact?: Partner;
  destinationContact?: Partner;
  serviceType?: ServiceType;
  type?: ServiceType;
  forwarder?: Partner;
  supplier?: Partner; // @deprecated - Usar suppliers en su lugar
  suppliers?: Partner[]; // Lista de suppliers (puede estar vacía o no existir)
  /** Fallback cuando suppliers/supplierIds vienen vacíos; mismo dato desde otro origen (ej. API) */
  serviceSuppliers?: Partner[];
  shipper?: Partner;
  consignee?: Partner;
  aduanaAgency?: Partner;
  serviceOrders?: ServiceOrder[];
  documents?: Document[];
  chatId: number;
  chat?: Chat;
  flow?: Flow;
  /** true/false cuando el backend lo informa; false = el Servicio no tiene Flujo asociado (SOU-525) */
  hasFlow?: boolean;
  equipments?: Equipment[];
  servicePricing?: ServicePricing;
}

/**
 * Obtiene suppliers y supplierIds de un Service con fallback a serviceSuppliers cuando las propiedades
 * habituales no existen o vienen vacías.
 */
export function getServiceSuppliersResolved(service: Service | null | undefined): { suppliers: Partner[]; supplierIds: number[] } {
  if (!service) return { suppliers: [], supplierIds: [] };
  const hasSuppliers = service.suppliers && service.suppliers.length > 0;
  const hasSupplierIds = service.supplierIds && service.supplierIds.length > 0;
  const hasServiceSuppliers = service.serviceSuppliers && service.serviceSuppliers.length > 0;

  const suppliers: Partner[] = hasSuppliers
    ? [...service.suppliers!]
    : hasServiceSuppliers
      ? [...service.serviceSuppliers!]
      : [];
  if (service.supplier && !suppliers.some(s => s.id === service.supplier!.id)) {
    suppliers.push(service.supplier);
  }

  const supplierIds: number[] = hasSupplierIds
    ? [...service.supplierIds!]
    : suppliers.length > 0
      ? suppliers.map(s => s.id)
      : [];

  return { suppliers, supplierIds };
}

export interface ServiceCreate {
  "projectId": number,
  "name": string, // Cambiara a name
  "typeId": number,
  "startDatePlan"?: string,
  "endDatePlan"?: string,
  "forwarderId"?: number,
  "supplierId"?: number, // @deprecated - Usar supplierIds en su lugar
  "supplierIds"?: number[], // Lista de IDs de suppliers (puede estar vacía o no existir)
  "shipperId"?: number,
  "consigneeId"?: number,
  "originId"?: string, // Cambiara a originId
  "destinationId"?: string, // Cambiara a destinationId
  originContactId?: number;
  destinationContactId?: number;
  "technicalSpecifications"?: string,
  "frequency"?: string,
  totalPlanned?: number | null;
  integrate: boolean,
  servicePricingPayload: ServicePricing,
}

export interface ServiceType {
  id: number;
  name: string;
  icon?: string;
  isActive?: boolean;
  flow: Flow;
}

export interface TypeAnalyticService {
  id: number;
  name: string;
  icon?: string;
  isActive?: boolean;
  flow: Flow;
}

export interface ServiceGood {
  "id": number,
  "amount": number,
  "unitMeasure": string,
  "unitVolume": string,
  "grossUnitWeight": number,
  "unitNetWeight": number,
  "sku": string,
  "serviceId": number,
  "goodId": number
}

export interface ServiceGoodCreate {
  "amount": number,
  "unitMeasure": string,
  "unitVolume": string,
  "grossUnitWeight": number,
  "unitNetWeight": number,
  "sku": string,
  "serviceId": number,
  "goodId": number
}
